import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic'

export const THREE_YEAR_PLAN_ID = 'PCP001'
export const TEN_YEAR_PLAN_ID = 'PCP003'
/* these values directly correlate to the values in the cartridges\app\client\mhj_app_headless\cartridge\scripts\config\pcp-price-matrix.json
 * in the sfcc codebase. Note that if this is updated we will additionally need to update these values here to ensure the correct plans are
 * being offered on the frontend
 */
const MAX_THREE_YEAR_PLAN_PRICE = 19999.99
const MAX_TEN_YEAR_PLAN_PRICE = 50000.0

export const getProductCarePlans = (
  retailPrice: number,
  options: ShopperProductsTypes.Option[],
): ShopperProductsTypes.OptionValue[] => {
  const noPlan = options.find((option: ShopperProductsTypes.OptionValue) => option.price === 0)
  const threeYearPlan = getYearPlan(THREE_YEAR_PLAN_ID, retailPrice, options)
  const tenYearPlan = getYearPlan(TEN_YEAR_PLAN_ID, retailPrice, options)
  return [noPlan, threeYearPlan, tenYearPlan].filter(
    (plan): plan is ShopperProductsTypes.OptionValue => plan !== null && plan !== undefined,
  )
}

const getYearPlan = (planID: string, retailPrice: number, options: ShopperProductsTypes.OptionValue[]) => {
  const foundOption = options.reduce<ShopperProductsTypes.OptionValue | null>((found, option) => {
    if (option.id?.includes(planID)) {
      const price = parseInt(option.id.split(planID)[1], 10)
      if (
        !isNaN(price) &&
        price <= retailPrice &&
        retailPrice <= (planID === THREE_YEAR_PLAN_ID ? MAX_THREE_YEAR_PLAN_PRICE : MAX_TEN_YEAR_PLAN_PRICE)
      ) {
        // @ts-ignore
        if (!found || option.price > found.price) {
          return option
        }
      }
    }
    return found
  }, null)
  return foundOption
}
